import React from 'react';
import { Helmet } from 'react-helmet-async';

import { APP_URL } from 'utils/env';

const BASE = (APP_URL || '').replace(/\/$/, '');

// Per-route SEO / social meta. Sets a unique title, meta description, canonical
// URL and Open Graph tags for each screen (react-helmet-async is provided at
// the app root). JS-rendering crawlers (Google) pick these up per route; the
// static index.html carries the homepage defaults for non-JS crawlers.
export default function Seo({ title, description, path = '/', image }) {
  const canonical = `${BASE}${path}`;
  const img = image && (image.startsWith('http') ? image : `${BASE}${image}`);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      {img ? <meta property="og:image" content={img} /> : null}
      {img ? <meta name="twitter:image" content={img} /> : null}
    </Helmet>
  );
}
